<template>
  <div ref="cardRef" class="lazy-assortment-card">
    <AssortmentCard v-if="isVisible" v-bind="{ ...props, ...attrs }" />
    <div v-else class="placeholder"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, useAttrs } from 'vue';
import AssortmentCard, { type AssortmentCardProps } from './AssortmentCard.vue';

const props = defineProps<AssortmentCardProps>();
const attrs = useAttrs();

const cardRef = ref<HTMLElement>();
const isVisible = ref(false);
let observer: IntersectionObserver | null = null;

onMounted(() => {
  if (cardRef.value) {
    observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          isVisible.value = true;
          observer?.unobserve(entry.target);
        }
      },
      {
        rootMargin: '200px',
        threshold: 0,
      },
    );

    observer.observe(cardRef.value);
  }
});

onUnmounted(() => {
  if (observer && cardRef.value) {
    observer.unobserve(cardRef.value);
  }
});
</script>

<style lang="scss" scoped>
.lazy-assortment-card {
  min-height: 280px;
}

.placeholder {
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #999;
  font-size: 14px;
}
</style>
